/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_5_SolutionInputs */

const es_home_usecases_item_5_solution = /** @type {(inputs: Home_Usecases_Item_5_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscá: 'documentos fiscales 2024 o contratos con cláusula NDA'. Obtenés: Listado completo con filtros avanzados.`)
};

const en_home_usecases_item_5_solution = /** @type {(inputs: Home_Usecases_Item_5_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search: 'fiscal documents 2024 or contracts with NDA clause'. Get: Complete listing with advanced filters.`)
};

/**
* | output |
* | --- |
* | "Search: 'fiscal documents 2024 or contracts with NDA clause'. Get: Complete listing with advanced filters." |
*
* @param {Home_Usecases_Item_5_SolutionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_5_solution = /** @type {((inputs?: Home_Usecases_Item_5_SolutionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_5_SolutionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_5_solution(inputs)
	return en_home_usecases_item_5_solution(inputs)
});
export { home_usecases_item_5_solution as "home.usecases.item_5_solution" }